export default __webpack_public_path__ + "static/media/vik_iceland.4a358b0e.jpg";